export enum ReportExtension {
  PDF = "PDF",
  XLSX = "XLSX",
}
